/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br>
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;" width="1200" >
        <v-container   style="background-color:#006699; color:white;"></v-container>
          <!-- ===================================== DIALOGO DE SELEÇÃO DO CLIENTE INICIAL================================= -->
                 <template>
               <v-row justify="center">
                <v-dialog v-model="dialog"  max-width="900px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Selecione a dispesa</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                               <v-data-table :headers="headersTabela" :items="dispesasGeral">
                                  <template v-slot:item.selecione="{ item }">
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="#006699" style="color:white;" @click="SelecionaProduto(item)" v-on="on" v-bind="attrs" fab small><v-icon>done</v-icon></v-btn>
                                        </template>
                                        <span>Clique neste botão para selecionar este Produto.</span>
                                    </v-tooltip>
                                  </template>
                                  <template v-slot:item.custo="{ item }">
                                     <span>{{utilitarios.IntegerToMoneyValueFatura(item.custo)}}</span>
                                  </template>
                               </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

        <!-- ====================================== Fim do DIALOGO =============================================== -->
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
       <v-card-title>
        <span>Contas correntes -  Dispesas </span>
         <v-spacer></v-spacer>
         <v-row style="border:1px solid #ccc;width:420px;height:170px;">
          <v-col md="5">
            <span style="font-size:15px;">Ver Conta Corrente de:</span>
            <v-text-field  label="Código do Produto" :disabled="true" v-model="txtCliente" ></v-text-field>
        </v-col>
        <v-col md="1">
            <v-btn fab small @click="PesquisarCliente()" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
        </v-col>
        <v-col md="3">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                            style="margin-left:80px;"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="3">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                    <v-col md="5" style="margin-top:-35px;">
                        <v-combobox
                            v-model="mesSelecionado"
                            :items="meses"
                            item-text="nome"
                            item-value="pk_mes"
                            label="Filtragem por mês"
                            @change="SelecionaMes()"
                      ></v-combobox>        </v-col>

        </v-row>
      </v-card-title>
        <template>
          <v-data-table :headers="headers" :items="dispesas">
               <template v-slot:item.custo="{ item }">
                    <span >{{utilitarios.IntegerToMoneyValueFatura(item.custo)}}</span>
                </template>
          </v-data-table>
        </template>
        <hr>
            <template  >
              <v-row>
                 <v-col md="4">
                    <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de movimentações: <v-chip>{{dispesas.length}}</v-chip></span>
                 </v-col>
                 <v-col md="4">
                 </v-col>
                 <v-col md="4">
                    <span>Valor Saidas: <v-chip>{{utilitarios.IntegerToMoneyValueFatura(totalDebito)}} </v-chip></span>
                 </v-col>
              </v-row>

            </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    alert: false,
    iconAlert: '',
    alertType: '',
    totalDebitoVar: 0,
    colorAlert: '',
    utilitarios: utilitarios,
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tab: null,
    mesSelecionado: null,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    txtCliente: null,
    clientes: [],
    meses: [],
    dispesasGeral: [],
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    contaCorrente: [],
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    dispesas: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headersTabela: [
      { text: 'Descrição da dispesa', value: 'dispesa' },
      { text: 'Data da operação', value: 'data_' },
      { text: 'Categoria', value: 'categoria' },
      { text: 'Subcategoria', value: 'subcategoria' },
      { text: 'Tipo de dispesa', value: 'tipo' },
      { text: 'Custo', value: 'custo' },
      { text: 'Registrada por', value: 'autor' },
      { text: 'Selecione', value: 'selecione' }
    ],
    headers: [
      { text: 'Descrição da dispesa', value: 'dispesa' },
      { text: 'Data da operação', value: 'data_' },
      { text: 'Categoria', value: 'categoria' },
      { text: 'Subcategoria', value: 'subcategoria' },
      { text: 'Tipo de dispesa', value: 'tipo' },
      { text: 'Custo', value: 'custo' },
      { text: 'Registrada por', value: 'autor' }
    ]

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    totalDebito () {
      let total = 0
      this.dispesas.forEach(element => {
        total += element.custo
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return total
    },
    totalSaidas () {
      let saidas = 0
      this.contaCorrente.forEach(element => {
        saidas += parseInt(element.qtd_venda)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return saidas
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
    this.ListarMeses()
  },

  methods: {
    async initialize () {
      try {
        this.progresso = true
        this.dispesas = await axios
          .get('/DispesasFindAll')
          .then(res => res.data)
        this.dispesasGeral = this.dispesas
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async ListarMeses () {
      try {
        this.progresso = true
        this.meses = await axios
          .get('/ListarMeses')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    SelecionaProduto (item) {
      this.txtCliente = item.dispesa
      this.DispesasFiltradas(this.txtCliente).then(() => {
        this.dialog = false
      })
    },
    async DispesasFiltradas (valor) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dispesas = await axios
          .get('/despesasFindByDesc/' + valor)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async DispesasFiltradasPorMes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.dispesas = await axios
          .get('/despesasFindByMes/' + this.mesSelecionado.pk_mes + '/' + this.txtCliente)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    // METHODO FOR VALIDATION
    PesquisarCliente () {
      this.dialog = true
    },
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    async  SelecionaMes () {
      this.DispesasFiltradasPorMes()
    },

    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          // eslint-disable-next-line no-mixed-operators
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}

</style>
